import { useMemo } from 'react';
import { bi } from '../../../services/loggers/bi';
import { mediaManagerLearnMoreClick } from '@wix/bi-logger-media-data/v2';
import { BIPageName } from '../../../constants/Bi';

export enum ClickOrigin {
  FilesImporter = 'files_importer',
  WixApp = 'wix_app',
  Trash = 'trash',
  PermanentlyDeletePopUp = 'permanently_delete_pop_up',
  OopsScreen = 'oops_screen',
  AddMediaBar = 'add_media_bar',
}

export const useTrackLearnMoreClickAnalytics = () =>
  useMemo(
    () => ({
      trackLearnMoreClick: (clickOrigin: ClickOrigin, errorType: string = '') =>
        bi.logger().report(mediaManagerLearnMoreClick({ clickOrigin, errorType, pageName: BIPageName.MediaManager })),
    }),
    [],
  );
